<span class="pi pi-power-off" tabindex="0" title="Close" (click)="closeAndRemove()" (keydown)="closeAndRemove()"></span>
